import React from "react";
import Edit from "./Edit";
import Overview from "./Overview";
export const Service = () => {
  return (
    
      <Overview />
    
  );
};

export const EditService = () => {
  return (
    
      <Edit />
    
  );
};
